import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '../../images/icons/checkedStepper.svg';
import StepConnector from '@material-ui/core/StepConnector';
let stepIcons = {};
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 13
  },
  active: {
    '& $line': {
      backgroundColor: '#0FA7B1'
    }
  },
  completed: {
    '& $line': {
      backgroundColor: '#0FA7B1'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#B1E6E9',
    borderRadius: 1
  }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#B1E6E9',
    zIndex: 1,
    color: '#fff',
    width: 27,
    height: 27,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    color: '#0FA7B1',

    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundColor: '#0FA7B1'
  }
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;
  const icons = stepIcons;
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {completed ? <img src={Check} alt="Check" /> : icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node
  // icons: PropTypes.node
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

function getSteps(props) {
  return props.stepsText;
}

export default function CustomizedSteppers(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  useEffect(() => {
    setActiveStep(props.activeStep);
  }, [activeStep]);

  const steps = props.stepsText;
  stepIcons = props.stepIcons;
  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  if (activeStep !== false) {
    return (
      <div className={classes.root}>
        <Stepper
          className="mt-4 bg-grey-950"
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
          style={props?.styles}
        >          
          {steps.map(label => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    );
  } else {
    return (
      <div>
        <p>Loading please wait. . .</p>
      </div>
    );
  }
}
